import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

export default function CardContent({ children, className = '', style, sx, ...props }) {
  return <div className={`ui-card-content ${className}`.trim()} style={mergeSx(sx, style)} {...props}>{children}</div>;
}
